import { createElement, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { NotFoundContainer } from "./NotFoundContainer";

enum RedirectTriggerPageContainerQueryApplication {
  APP = "app",
  WEB = "web",
}

export const RedirectTriggerPageContainer = () => {
  const isBrowser = typeof window !== "undefined";
  const isRunningInWebview = isBrowser && !!window?.ReactNativeWebView;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const application = searchParams.get("application");
  const route = searchParams.get("route");

  const [allAttemptsMade, setAllAttemptsMade] = useState(false);

  const hasExecutedRef = useRef(false);

  useEffect(() => {
    if (!isBrowser) return;
    if (!application || !route) return;
    if (hasExecutedRef.current) return;

    const tryPostMessage = (attempt = 0) => {
      const webview = window?.ReactNativeWebView;

      if (
        webview &&
        typeof webview.postMessage === "function" &&
        application === RedirectTriggerPageContainerQueryApplication.APP
      ) {
        hasExecutedRef.current = true;

        webview.postMessage(
          JSON.stringify({
            type: "REDIRECT_TO",
            payload: route,
          })
        );

        return;
      }

      if (attempt < 20) {
        setTimeout(() => tryPostMessage(attempt + 1), 50);
      } else {
        setAllAttemptsMade(true);
      }
    };

    if (application === RedirectTriggerPageContainerQueryApplication.APP) {
      tryPostMessage();
      return;
    }

    if (application === RedirectTriggerPageContainerQueryApplication.WEB) {
      hasExecutedRef.current = true;
      window.location.href = route;
    }
  }, [isBrowser, application, route]);

  if (!application || !route) {
    return createElement(NotFoundContainer);
  }

  if (
    isRunningInWebview &&
    application === RedirectTriggerPageContainerQueryApplication.APP
  ) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: "REDIRECT_TO",
        payload: route,
      })
    );
    return null;
  }

  if (allAttemptsMade) {
    return createElement(
      "div",
      {},
      createElement("h1", {}, "All attempts made, failed to redirect")
    );
  }

  return null;
};
